import { GenIcon } from '../helpers/IconBase.es.js';

const CongratulationColored = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { viewBox: "0 0 20 20", fill: "none" },
    child: [
      {
        tag: "g",
        attr: { clipPath: "url(#clip0_8996_2230)" },
        child: [
          {
            tag: "path",
            attr: {
              d: "M12.0313 15.2187L1.75008 19.1562C0.906326 19.4687 0.0625764 18.6562 0.406326 17.8125L4.31258 7.5C4.18758 8.65625 5.28133 10.625 7.09383 12.4375C8.90633 14.25 10.9063 15.3437 12.0313 15.2187Z",
              fill: "#FECB4D"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M4.34375 11.3438C4.875 12.0938 5.5 12.8125 6.09375 13.4375C6.6875 14.0313 7.40625 14.6562 8.1875 15.1875L1.96875 17.5625L4.34375 11.3438Z",
              fill: "#F9B826"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M1.37505 19.5312C0.906297 19.5312 0.500047 19.3125 0.250047 18.9375C4.68679e-05 18.5625 -0.0312031 18.125 0.125047 17.6875L4.0313 7.375C4.0938 7.21875 4.25005 7.15625 4.4063 7.1875C4.56255 7.21875 4.6563 7.375 4.6563 7.53125C4.5313 8.59375 5.6563 10.5 7.3438 12.2187C8.9688 13.8437 10.7813 14.9062 11.875 14.9062H12.0313C12.1875 14.875 12.3438 15 12.375 15.1562C12.4063 15.3125 12.3438 15.4688 12.1875 15.5312L1.87505 19.4375C1.68755 19.5 1.5313 19.5312 1.37505 19.5312ZM4.18755 8.71875L0.687547 17.9375C0.562547 18.25 0.656297 18.4688 0.750047 18.5938C0.937547 18.875 1.31255 19 1.62505 18.875L10.8125 15.375C9.62505 14.9688 8.18755 14 6.87505 12.6875C5.5313 11.3125 4.56255 9.90625 4.18755 8.71875Z",
              fill: "#2A3C65"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M11.8438 15.5312C10.5626 15.5312 8.65632 14.4374 6.87507 12.6562C5.03132 10.8124 3.90632 8.7812 4.00007 7.4687C4.03132 7.0937 4.15632 6.81245 4.37507 6.62495C5.00007 5.99995 6.25007 6.1562 7.75007 7.0312C7.90632 7.12495 7.93757 7.31245 7.84382 7.4687C7.75007 7.62495 7.56257 7.6562 7.40632 7.56245C6.21882 6.8437 5.18757 6.6562 4.78132 7.0312C4.68757 7.12495 4.62507 7.2812 4.59382 7.49995C4.50007 8.5937 5.62507 10.4999 7.28132 12.1874C8.96882 13.8749 10.9063 14.9999 11.9688 14.8749C12.1876 14.8437 12.3438 14.7812 12.4376 14.6874C12.8438 14.3124 12.6251 13.2812 11.9063 12.0624C11.8126 11.9062 11.8751 11.7187 12.0313 11.6249C12.1876 11.5312 12.3751 11.5937 12.4688 11.7499C13.3751 13.3124 13.5313 14.5312 12.8751 15.1249C12.6876 15.3124 12.4063 15.4374 12.0313 15.4999C12.0001 15.5312 11.9376 15.5312 11.8438 15.5312Z",
              fill: "#2A3C65"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M8.15631 17C8.09381 17 8.00006 16.9688 7.93756 16.9063C4.28131 13.6563 3.96881 10.0938 4.09381 8.28127C4.09381 8.09377 4.25006 7.96878 4.43756 8.00003C4.62506 8.00003 4.75006 8.15628 4.71881 8.34378C4.59381 10.0313 4.87506 13.375 8.37506 16.4688C8.50006 16.5938 8.50006 16.7813 8.40631 16.9063C8.31256 16.9688 8.25006 17 8.15631 17Z",
              fill: "#2A3C65"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M5.875 17.875C5.78125 17.875 5.71875 17.8437 5.65625 17.7812C3.78125 15.9062 2.75 13.7187 2.53125 11.375C2.53125 11.2187 2.65625 11.0625 2.8125 11.0312C3 11 3.125 11.1562 3.15625 11.3125C3.34375 13.5312 4.34375 15.5625 6.09375 17.3437C6.21875 17.4687 6.21875 17.6562 6.09375 17.7812C6.03125 17.8437 5.96875 17.875 5.875 17.875Z",
              fill: "#2A3C65"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M3.65626 18.75C3.56251 18.75 3.46876 18.7188 3.40626 18.625C2.40626 17.4063 1.68751 16.0938 1.28126 14.6875C1.25001 14.5313 1.34376 14.375 1.50001 14.3125C1.65626 14.2813 1.84376 14.375 1.87501 14.5313C2.25001 15.8438 2.93751 17.0938 3.87501 18.2188C4.00001 18.3438 3.96876 18.5625 3.84376 18.6563C3.81251 18.7188 3.71876 18.75 3.65626 18.75Z",
              fill: "#2A3C65"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M10.4688 13.4063C10.2812 13.375 10.1562 13.25 10.1562 13.0625C10.1562 12.9688 10.4375 10.5 14.2188 8.93752C14.375 8.87502 14.5625 8.93752 14.625 9.09377C14.6875 9.25002 14.625 9.43752 14.4688 9.50002C11.0625 10.9375 10.7812 13.0313 10.7812 13.125C10.75 13.2813 10.625 13.4063 10.4688 13.4063Z",
              fill: "#2A3C65"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M6.43753 9.37502C6.28128 9.37502 6.15628 9.25002 6.12503 9.09377C6.09378 8.93752 6.21877 8.78127 6.40627 8.75002C6.50002 8.75002 8.59377 8.46877 10.0313 5.06252C10.0938 4.90627 10.2813 4.84377 10.4375 4.90627C10.5938 4.96877 10.6563 5.15627 10.5938 5.31252C9.00003 9.09377 6.56253 9.37502 6.43753 9.37502Z",
              fill: "#2A3C65"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M9.37501 3.71876C9.34376 3.71876 9.31251 3.71876 9.28126 3.71876C9.12501 3.65626 9.03126 3.50001 9.06251 3.31251L9.59376 1.59376C9.65626 1.43751 9.81251 1.34376 10 1.37501C10.1563 1.43751 10.25 1.59376 10.2188 1.78126L9.68751 3.50001C9.62501 3.62501 9.50001 3.71876 9.37501 3.71876Z",
              fill: "#2A3C65"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M10.5 3.12501C10.4688 3.12501 10.4375 3.12501 10.4063 3.12501L8.71876 2.59376C8.56251 2.53126 8.46876 2.37501 8.50001 2.18751C8.56251 2.03126 8.71876 1.93751 8.90626 1.96876L10.5938 2.50001C10.75 2.56251 10.8438 2.71876 10.8125 2.90626C10.75 3.03126 10.625 3.12501 10.5 3.12501Z",
              fill: "#2A3C65"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M16.3437 4.09372H16.125C15.9062 4.09372 15.6875 4.18747 15.5625 4.40622L15.4375 4.56247C15.0937 5.03122 14.375 4.90622 14.1875 4.37497L14.125 4.18747C14.0625 3.96872 13.875 3.78122 13.6562 3.71872L13.4687 3.65622C12.9062 3.46872 12.7812 2.74998 13.2812 2.40623L13.4375 2.28123C13.625 2.15623 13.75 1.93748 13.7187 1.68748V1.49998C13.7187 0.906225 14.375 0.593725 14.8437 0.937475L15 1.06248C15.1875 1.18748 15.4375 1.24998 15.6562 1.15623L15.8437 1.09373C16.4062 0.906225 16.9062 1.43748 16.7187 1.96873L16.6562 2.15623C16.5937 2.37498 16.625 2.62497 16.75 2.78122L16.875 2.93747C17.25 3.43747 16.9062 4.09372 16.3437 4.09372Z",
              fill: "#27D1FF"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M14.9688 3.46875C14.8125 3.21875 14.5938 3 14.3438 2.84375C14.5312 2.625 14.6875 2.34375 14.75 2.0625C14.9687 2.15625 15.2188 2.21875 15.4375 2.21875H15.5938C15.5625 2.5 15.625 2.8125 15.75 3.09375C15.4375 3.15625 15.1875 3.28125 14.9688 3.46875Z",
              fill: "#02BEFF"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M18.9688 9.53123H18.8751C18.6563 9.53123 18.4376 9.62498 18.2813 9.81248L18.2188 9.87498C17.8751 10.3437 17.1563 10.2187 16.9688 9.68748L16.9376 9.59373C16.8751 9.37498 16.6876 9.18748 16.4688 9.12498L16.3751 9.09373C15.8126 8.93748 15.7188 8.18748 16.1876 7.84373L16.2501 7.78123C16.4376 7.65623 16.5626 7.43748 16.5626 7.18748V7.09373C16.5626 6.49998 17.2188 6.18748 17.6876 6.53123L17.7501 6.59373C17.9376 6.71873 18.1876 6.78123 18.4063 6.68748L18.5001 6.65623C19.0626 6.46873 19.5626 6.99998 19.3751 7.53123V7.68748C19.3126 7.90623 19.3438 8.15623 19.4688 8.31248L19.5313 8.37497C19.9063 8.87497 19.5626 9.53123 18.9688 9.53123Z",
              fill: "#FF7DAF"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M17.7813 8.875C17.6563 8.6875 17.4688 8.5 17.2812 8.375C17.4375 8.1875 17.5312 7.96875 17.5938 7.75C17.7812 7.8125 18 7.875 18.2188 7.875H18.3125C18.3125 8.125 18.3438 8.34375 18.4375 8.59375C18.1875 8.59375 17.9688 8.71875 17.7813 8.875Z",
              fill: "#FF5892"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M14.875 5.15625C14.4375 5.15625 14.0313 4.875 13.9063 4.46875L13.8438 4.28125C13.8125 4.15625 13.6875 4.03125 13.5938 4L13.4063 3.9375C13.0313 3.8125 12.75 3.5 12.6875 3.09375C12.625 2.71875 12.8125 2.34375 13.125 2.125L13.25 2C13.3125 1.96875 13.4375 1.84375 13.4063 1.6875V1.65625V1.5C13.4063 0.9375 13.8438 0.46875 14.4063 0.46875C14.625 0.46875 14.8438 0.53125 15.0313 0.6875L15.1875 0.8125C15.2813 0.875 15.4375 0.90625 15.5313 0.875L15.75 0.8125C16.1875 0.65625 16.6563 0.8125 16.9063 1.1875C17.0938 1.46875 17.1563 1.78125 17.0313 2.09375L16.9688 2.28125C16.9375 2.40625 16.9688 2.5625 17 2.625L17.125 2.78125C17.375 3.125 17.4063 3.53125 17.25 3.90625C17.0938 4.25 16.75 4.46875 16.3438 4.46875H16.125C16.0313 4.46875 15.9063 4.5 15.8438 4.625L15.8125 4.65625L15.6875 4.8125C15.5 5 15.1875 5.15625 14.875 5.15625ZM14.0313 1.65625C14.0625 2 13.9063 2.34375 13.625 2.53125L13.5 2.625C13.3438 2.71875 13.2813 2.875 13.3125 3C13.3438 3.15625 13.4375 3.28125 13.5938 3.3125L13.75 3.4375C14.0625 3.53125 14.3438 3.78125 14.4063 4.125L14.4688 4.3125C14.5313 4.5 14.7188 4.5625 14.8438 4.5625C14.9063 4.5625 15.0625 4.53125 15.1563 4.40625L15.2813 4.25C15.4375 3.96875 15.75 3.8125 16.0938 3.8125H16.3125C16.4688 3.8125 16.5938 3.71875 16.6563 3.59375C16.6875 3.53125 16.75 3.34375 16.5938 3.15625L16.4688 3C16.2813 2.78125 16.2188 2.40625 16.3125 2.09375L16.4375 1.875C16.5 1.71875 16.4375 1.59375 16.4063 1.53125C16.3125 1.40625 16.125 1.34375 15.9688 1.40625L15.7813 1.46875C15.6875 1.5 15.5938 1.53125 15.4688 1.53125C15.25 1.53125 15.0625 1.46875 14.875 1.34375L14.6875 1.1875C14.5 1.03125 14.0625 1.125 14.0625 1.5V1.65625H14.0313Z",
              fill: "#2A3C65"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M17.6563 10.4688C17.2188 10.4688 16.8125 10.1875 16.6875 9.78125L16.6563 9.6875C16.625 9.5625 16.5 9.46875 16.4063 9.40625L16.2813 9.375C15.9375 9.28125 15.6563 9 15.5938 8.625C15.5313 8.25 15.6875 7.84375 15.9688 7.59375L16.0313 7.53125C16.0313 7.53125 16.0625 7.5 16.0938 7.5C16.1875 7.4375 16.2813 7.3125 16.2813 7.15625V7.0625C16.2813 6.5 16.7188 6.03125 17.2813 6.03125C17.5 6.03125 17.7188 6.09375 17.9063 6.25L17.9375 6.28125L17.9688 6.3125C18.0938 6.375 18.2188 6.40625 18.3125 6.375L18.4375 6.34375C18.875 6.1875 19.3438 6.34375 19.5938 6.71875C19.7813 6.96875 19.8125 7.28125 19.75 7.5625V7.65625V7.75C19.7188 7.875 19.75 8.03125 19.7813 8.09375L19.8125 8.125L19.8438 8.15625C20.0938 8.46875 20.125 8.90625 19.9688 9.25C19.7813 9.59375 19.4375 9.8125 19.0313 9.8125H18.9375C18.8125 9.8125 18.6875 9.875 18.5938 9.96875L18.5313 10.0312C18.25 10.3437 17.9688 10.4688 17.6563 10.4688ZM16.4375 8.03125L16.4063 8.0625L16.375 8.09375C16.2188 8.21875 16.1875 8.375 16.2188 8.5C16.2188 8.5625 16.2813 8.71875 16.4688 8.78125L16.5625 8.8125C16.875 8.90625 17.125 9.15625 17.2188 9.5L17.25 9.59375C17.3125 9.78125 17.5 9.84375 17.625 9.84375C17.6875 9.84375 17.8438 9.8125 17.9375 9.6875L17.9688 9.65625L18.0313 9.59375C18.2188 9.375 18.5313 9.21875 18.8438 9.21875H18.9375C19.0938 9.21875 19.2188 9.125 19.3125 9C19.375 8.875 19.375 8.71875 19.2813 8.5625L19.25 8.53125L19.2188 8.5C19.0313 8.28125 18.9688 7.9375 19.0625 7.625V7.5C19.0625 7.46875 19.0625 7.4375 19.0938 7.40625C19.1563 7.25 19.0938 7.125 19.0625 7.0625C18.9688 6.9375 18.7813 6.875 18.625 6.9375L18.5313 6.96875C18.4375 7 18.3438 7.03125 18.2188 7.03125C18 7.03125 17.8125 6.96875 17.625 6.84375C17.5938 6.84375 17.5938 6.8125 17.5625 6.8125L17.5 6.78125C17.2813 6.625 16.875 6.75 16.875 7.09375V7.1875C16.875 7.53125 16.7188 7.84375 16.4375 8.03125Z",
              fill: "#2A3C65"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M8.8126 11.2188C8.7501 11.2188 8.6876 11.1875 8.6251 11.1563C8.46885 11.0625 8.4376 10.875 8.5626 10.7188C8.6876 10.5313 11.6876 6.34377 15.0626 6.00003C15.2501 5.96878 15.3751 6.09377 15.4064 6.28127C15.4376 6.43752 15.3126 6.59377 15.1251 6.62502C12.0314 6.93752 9.09385 11.0313 9.0626 11.0938C9.0001 11.1875 8.90635 11.2188 8.8126 11.2188Z",
              fill: "#2A3C65"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M15.6875 12.9063C15.6563 12.9063 15.625 12.9063 15.5938 12.9063C15.4375 12.8438 15.3438 12.6875 15.375 12.5L15.9063 10.8125C15.9688 10.6563 16.125 10.5625 16.3125 10.5938C16.4688 10.6563 16.5625 10.8125 16.5313 11L16 12.6875C15.9375 12.8125 15.8125 12.9063 15.6875 12.9063Z",
              fill: "#2A3C65"
            }
          },
          {
            tag: "path",
            attr: {
              d: "M16.7813 12.3125C16.75 12.3125 16.7188 12.3125 16.6875 12.3125L15 11.7813C14.8438 11.7188 14.75 11.5625 14.7813 11.375C14.8438 11.2188 15 11.125 15.1875 11.1563L16.875 11.6875C17.0313 11.75 17.125 11.9063 17.0938 12.0938C17.0313 12.2188 16.9063 12.3125 16.7813 12.3125Z",
              fill: "#2A3C65"
            }
          }
        ]
      },
      {
        tag: "defs",
        attr: {},
        child: [
          {
            tag: "clipPath",
            attr: { id: "clip0_8996_2230" },
            child: [
              {
                tag: "rect",
                attr: { width: "20", height: "20", fill: "white" }
              }
            ]
          }
        ]
      }
    ]
  })(props);
};

export { CongratulationColored };
